module.exports = __webpack_public_path__ + "../resources/img/serial_img.f8bc16cf.png";